<mat-card *ngIf="data">
    <mat-card-content>
      <h2 class="info-title">{{data.title}}</h2>
      <div class="info-description">
        {{data.description}}
      </div>
  
      <div class="career-list">
        <app-portal-career-promoted-item
          *ngFor="let career of data.items"
          [career]="career"
        />
      </div>
  
      <div class="text-center mt-2">
        <app-portal-button 
            [target]="data.buttonTarget"
            [link]="data.buttonLink"
            classes="w-phone-100"
            color="primary" 
            [title]="data.buttonText"/>
      </div>
    </mat-card-content>
</mat-card>
  